import React, { useMemo } from 'react';
import { Dropdown, DropdownItem, DropdownMenu } from 'reactstrap';
import { useQueueContentChatContext } from '../../../../../../hooks/useQueueContentChat';

export const FilterTagsOptions = ({
  open,
  openDropDown,
  handlerFilter,
  children,
  tags
}) => {
  const { filters } = useQueueContentChatContext();
  const tagsFiltered = useMemo(() => {
    return filters['TAG'];
  }, [filters]);

  return (
    <Dropdown
      direction="right"
      style={{
        display: 'flex',
        border: 'none',
        margin: 0,
        padding: 0,
        width: '100%',
        height: '100%',
        color: 'black'
      }}
      onMouseEnter={() => openDropDown(true)}
      onMouseLeave={() => {
        openDropDown(false);
      }}
      isOpen={open}
      toggle={() => openDropDown(!open)}
    >
      {children}
      <DropdownMenu
        style={{
          marginLeft: '-10px'
        }}
        className="DropdownMenu"
      >
        <DropdownItem
          toggle={false}
          onClick={(e) => {
            handlerFilter('ALL', 'TAG');
            document.getElementById(`dropdownItemTagsALL`).checked = true;
            e.stopPropagation();
          }}
        >
          <input
            id={`dropdownItemTagsALL`}
            type="checkbox"
            checked={!tagsFiltered?.length}
            onChange={() => handlerFilter('ALL', 'TAG')}
            onClick={(e) => {
              handlerFilter('ALL', 'TAG');
              e.stopPropagation();
            }}
            style={{ marginRight: '5px' }}
          />
          Todas
        </DropdownItem>
        <DropdownItem divider />
        {tags?.map((tag, index) => {
          if (!tag) return null;
          return (
            <DropdownItem
              key={`dropdownitem+${tag.id}+${index}`}
              value={tag.id}
              toggle={false}
              onClick={(e) => {
                document.getElementById(
                  `dropdownitem+${tag.id}+${index}`
                ).checked = !document.getElementById(
                  `dropdownitem+${tag.id}+${index}`
                ).checked;
                handlerFilter(tag.id, 'TAG');
                e.stopPropagation();
              }}
            >
              <input
                id={`dropdownitem+${tag.id}+${index}`}
                type="checkbox"
                value={tag.id}
                checked={tagsFiltered?.includes(tag.id)}
                onClick={(e) => {
                  handlerFilter(tag.id, 'TAG');
                  e.stopPropagation();
                }}
                style={{ marginRight: '5px' }}
              />
              {tag.name}
            </DropdownItem>
          );
        })}
      </DropdownMenu>
    </Dropdown>
  );
};
